import { Deserializable } from '../deserializable';

export class UserIdentifiers implements Deserializable {
  public userId: number;
  public idNumber: string;
  public taxNumber: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
